export const BitcoinURL = () =>
  `https://api.coingecko.com/api/v3/coins/bitcoin`;

export const HistoricalChart = (id, days = 365, currency) =>
  `https://api.coingecko.com/api/v3/coins/${id}/market_chart?vs_currency=${currency}&days=${days}`;
